import { useState, useRef, forwardRef, useEffect, useContext, useMemo } from 'react';
// @ts-ignore
import { Portal,InputAdornment, Box, Typography, IconButton, TextField, Select, InputLabel, MenuItem, FormControl, Checkbox, Button, Dialog, Divider, OutlinedInput, Snackbar, Alert, ListItemText, Tabs} from '@mui/material';
// @ts-ignore
import SearchIcon from '@mui/icons-material/Search';
// @ts-ignore
import CloseIcon from '@mui/icons-material/Close';
import { IMaskInput, IMask } from 'react-imask';
import RangeDate from '../../components/RangeDate';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { StatusBars } from './staticresorces'
import moment from 'moment';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Scrollbars } from 'rc-scrollbars';
import wb from '../../images/markets/wb.png'
import ozon from '../../images/markets/ozon.png'
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
// @ts-ignore
import { Password } from '@mui/icons-material';
import CryptoJS from "crypto-js";
import { useLocalNotifications } from 'components/Events';
import { SelectMarketLocal } from 'components/SelectMarket';
// @ts-ignore
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import ClassicSearch from 'components/classicSearch';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
// @ts-ignore
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// @ts-ignore
import { TextFeature, TextInput } from 'components/EIComponents/LittleComponents';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '../../images/others/EditIcon.png';
import AddIcon from '../../images/others/AddIcon.png';
import Tooltip from "@mui/material/Tooltip";
import { PhoneInputGroup } from './PhoneInputGroup';


/*Это файл содержащий форматеры верхних панелей, тут описанно их поведение и отображение
Drag and drop имеет следующую структуру

./src
    ./api
        ./apiBridges 
            ./dndBridge.js  (Бриджи для дескриптора)
        ./descriptors
            ./addressableStorage.js (Дескрипторы)
    ./components
        ./DragDrop.js (Основной элемент drag end drop)
    ./utils
        ./dndutils
            ./cardformatters.js (Форматеры тикетов)
            ./containerformatters.js  (Форматеры контейнеров)
            ./staticresorces.js (Статические ресурсы)
            ./toppanelformaters.js  (Форматеры панелей фильтров)

Для создания нового элемента он размещается в соответствующем файле, после чего вкладывается в дескриптор, который работает как конструктор для данного меню
*/

const blocks = {
    h: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 23,
      maxLength: 2,
    },
    m: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 59,
      maxLength: 2,
    }
  }



  const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000 000 00 00 ######" // Маска с запасом
        definitions={{
          '#': /[0-9]/,
        }}
        inputRef={ref}
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  });

  export const NewClientDialog = ({ close, alter_cli = false }) => {
  const [fname, setFName] = useState('');
  const [tname, setTName] = useState('');
  const [state, setState] = useState('Unknown');
  const [countryCode, setCountryCode] = useState('+7'); // Задал дефолтный код
  const [number, setNumber] = useState('');
  const [email, setEmail] = useState('');
  const [infoOpen, setInfoOpen] = useState(false);
  const [tmpLogin, setTmpLogin] = useState('');
  const [tmpPass, setTmpPass] = useState('');
  
  const { socket } = useContext(SocketContext);
  const { showNotification } = useLocalNotifications();
  const { user_id, company_id } = useSelector(loginSelector);

  const InfoClickOpen = () => setInfoOpen(true);
  const InfoClickClose = () => {
    setInfoOpen(false);
    setTmpPass('');
    setTmpLogin('');
    close();
  };

  // Обработчик добавления
  const DialoghandleAdd = async () => {
    const emailRegex = /^.+@.+\..{2,}$/;
    
    // 1. Собираем только цифры для проверки длины (например: 79001234567)
    const digitsOnly = (countryCode + number).replace(/\D/g, '');
    
    // 2. ВОТ РЕШЕНИЕ: Добавляем плюсик в самое начало строки для бэкенда (например: +79001234567)
    const phoneWithPlus = '+' + digitsOnly;

    console.log("TEST", fname, phoneWithPlus, email);

    // Важно: длину проверяем у digitsOnly, а отправляем phoneWithPlus
    if ((fname !== '') && digitsOnly.length >= 11 && emailRegex.test(email)) {
      
      let check = await get("Registration/checkAuth", { login: phoneWithPlus });
      
      if (!check) {
        let user_info = undefined;
        if (alter_cli) {
          user_info = {
            fio: `${fname} ${tname}`, 
            email: email, 
            mobile_number: phoneWithPlus, // Сохраняем с плюсом
            parent: user_id,
          };
        } else {
          user_info = {
            fio: `${fname} ${tname}`, 
            email: email, 
            mobile_number: phoneWithPlus, // Сохраняем с плюсом
            company_id,
            manager_id: user_id,
            ip_id: "",
            api_key: "",
            status: state,
            data: ""
          };
        }

        let newUser = await post("Registration/addClient", {
          userInfo: user_info,
          authinfo: {
            login: phoneWithPlus, // Сохраняем логин с плюсом
            password: undefined
          }
        });

        if (newUser) {
          let obj = { manager_id: newUser.mng, company_id, client_id: newUser.id };
          if (alter_cli) { obj.alter_cli = user_id; }
          socket.emit('add_my_clients', obj);
          
          const decPass = CryptoJS.AES.decrypt(newUser.pass, 'pizdec').toString(CryptoJS.enc.Utf8);
          setTmpPass(decPass);
          setTmpLogin(phoneWithPlus);
          InfoClickOpen();
        }
      } else {
        showNotification({ id: 'errorCreateUser', type: 'error', message: 'Пользователь с таким номером уже зарегистрирован' });
      }
    } else if ((fname !== '') && digitsOnly.length < 11 && emailRegex.test(email)) {
      showNotification({ id: 'wrongNumber', type: 'error', message: 'Некорректный номер телефона' });
    } else if ((fname !== '') && digitsOnly.length >= 11 && !emailRegex.test(email)) {
      showNotification({ id: 'wrongEmail', type: 'error', message: 'Неправильно введена почта' });
    } else if ((fname === '') && digitsOnly.length >= 11 && emailRegex.test(email)) {
      showNotification({ id: 'noName', type: 'error', message: 'Не введено имя' });
    } else {
      showNotification({ id: 'noData', type: 'error', message: 'Недостаточно данных или данные некорректны' });
    }
  };

  return (
    <div style={{ height: '450px', width: '600px', overflow: "hidden" }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '15px' }}>
        <Typography variant="body1" sx={{ fontWeight: '800', fontSize: '30px', mt: 2 }}>
          {alter_cli ? "Добавить новый аккаунт" : "Добавить нового клиента"}
        </Typography>

        <TextField
          variant="filled"
          label="Имя"
          onChange={(e) => setFName(e.target.value)}
          sx={fieldStyle}
          InputProps={{ disableUnderline: true }}
        />
        
        <PhoneInputGroup 
          countryCode={countryCode} 
          setCountryCode={setCountryCode} 
          number={number} 
          setNumber={setNumber} 
        />

        <TextField
          variant="filled"
          label="Email"
          placeholder='example@yandex.ru'
          onChange={(e) => setEmail(e.target.value)}
          sx={fieldStyle}
          InputProps={{ disableUnderline: true }}
        />

          {!alter_cli && (
            <Select
              defaultValue={state}
              onChange={e => setState(e.target.value)}
              sx={selectStyle}
              MenuProps={{ sx: { '& .MuiMenu-paper': { backgroundColor: 'rgba(0,0,0,0)', boxShadow: 'none' } } }}
            >
              {StatusBars.map(el => (
                <MenuItem key={el.state} value={el.state} style={{ backgroundColor: el.color, borderRadius: '10px', marginBottom: '5px' }}>
                  {el.show}
                </MenuItem>
              ))}
            </Select>
          )}

          <div style={{ marginTop: '30px' }}>
            <Button variant="contained" onClick={close} sx={btnStyle}>Отмена</Button>
            <Button variant="contained" onClick={DialoghandleAdd} sx={btnStyle}>Добавить</Button>
          </div>
        </div>

        <Dialog
              open={infoOpen}
              onClose={InfoClickClose}
              PaperProps={{ sx: { borderRadius: "40px" } }}
            >
              <div style={{height:'300px', width:'600px', overflowX:"hidden", overflowY:"hidden"}}>
                <div style = {{position: 'relative', paddingTop: '15px'}}>
                  <div style = {{alignContent: 'center', alignItems: 'center'}}>
                      <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                          <Typography variant="body1" sx={{fontWeight: '800', fontSize: '25px', display: 'row', marginTop:'20px'}}>Разовая информация для клиента</Typography>
                          <Typography variant="body1" sx={{fontWeight: '800', fontSize: '20px', display: 'row', marginTop:'20px'}}>Логин: {tmpLogin}</Typography>
                          <Typography variant="body1" sx={{fontWeight: '800', fontSize: '20px', display: 'row', marginTop:'20px'}}>Пароль: {tmpPass}</Typography>
                          <Typography variant="body1" sx={{fontWeight: '800', fontSize: '20px', display: 'row', marginTop:'20px'}}>Информация отправлена на почту</Typography>
                      </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'20px'}}>
                    <Button variant="contained" onClick={InfoClickClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Закрыть</Button>
                  </div>
                </div>
              </div>
            </Dialog>
      </div>
    );
  };

  const fieldStyle = {
    backgroundColor: '#e0e0e0',
    marginTop: '10px',
    width: '70%',
    borderRadius: '10px',
    "& .MuiFilledInput-root": {
      backgroundColor: "#e0e0e0",
      borderRadius: '10px',
      "&:hover": { backgroundColor: "#d5d5d5" },
      "&.Mui-focused": { backgroundColor: "#e0e0e0" }
    }
  };

  const selectStyle = {
    ...fieldStyle,
    '.MuiOutlinedInput-notchedOutline': { border: 0 }
  };

  const btnStyle = {
    textTransform: 'none',
    margin: '10px',
    fontWeight: 'bold',
    backgroundColor: '#078376',
    '&:hover': { backgroundColor: '#05635a' }
  };

  // Компенет добавления тикета
  export const  AddTicketDialog = ({setListItems, setEmitFlag, listItems}) => {
    // Состояние модального окна
    const [open, setOpen] = useState(false);
    


    // Обработчики состояния модального окна
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
    const DialoghandleClose = () => {
      setOpen(false);
    };

  
    return(
      <div style={{display: 'inline-block', marginLeft: 'auto', marginRight: 0}}>
        <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', borderRadius: "10px"}} onClick={DialoghandleClickOpen}>Новый клиент</Button>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          // PaperProps={{ sx: { borderRadius: "40px" } }}
        >
          <NewClientDialog close={DialoghandleClose}/>
        </Dialog>
      </div>
    )
  }
  
  
  // Компонент описывающий верхнюю панель меню клиентов
  export const TopPanelNewClients = ({ds, setFilterName, setListItems, setEmitFlag, listItems, listTables, setListTables, setListTabs, listTabs}) => {

    // Поля фильтров
    /////////////////////////
    const [states, setStates] = useState(['Unknown', 'Argent', 'Gold', 'Emerald']);
    const [endTime, setEndTime] = useState([0,0]);
    const [startTime, setstartTime] = useState([0,0]);
    const [time, setTime] = useState([]);
    const [date, setDate] = useState([new Date(new Date().getTime() - 24 * 60 * 60 * 1000),  new Date()]);
    /////////////////////////////

    // Обработчики изменения фильтров
    ////////////////////////
    const handeUpdateEndTime = (time) => {
      let split = time.target.value.split(':');
      if (!split[1]){split[1] = 0}
      setEndTime(split)
    }
    const handeUpdateStartTime = (time) => {
      let split = time.target.value.split(':');
      if (!split[1]){split[1] = 0}
      setstartTime(split)
    }
    const handleChangeDate = (time) => {
      setTime(time);
      if (checkedTwo) setFilterName({timeStart: time[0], timeEnd: time[1]})
    }

    const handleChangeOnlyDate = (time) => {
      setDate(time);
      if (checkedTwo) setFilterName({timeStart: time[0], timeEnd: time[1]})
    }

    // @ts-ignore
    const timeCheck = (e) => {
      if (time.length !== 0) 
        {
            setCheckedTwo(!checkedTwo); 
            if (!checkedTwo){
              setFilterName({timeStart: new Date(new Date(time[0]).setHours(0,0,0,0)+(+startTime[0]*3600000)+(+startTime[1]*60000)), timeEnd: new Date(new Date(time[1]).setHours(0,0,0,0)+(+endTime[0]*3600000)+(+endTime[1]*60000))}); 
            }else 
            {setFilterName({timeStart: '', timeEnd: ''});}
        }
        else {setOpen(true);}
    }

    // @ts-ignore
    const dataCheck = (e) => {
      if (date.length !== 0) 
        {
          setCheckedFour(!checkedFour);
            if (!checkedFour){
              console.log('date on')
              setFilterName({dateStart: new Date(new Date(date[0]).setHours(0,0,0,0)), dateEnd: new Date(new Date(date[1]).setHours(0,0,0,0)+(23*3600000)+(59*60000))}); 
            }else 
            { console.log('date off'); setFilterName({dateStart: '', dateEnd: ''});}
        }
        else {setOpen(true);}
    }
    /////////////////////////////////////////////////////////////////


    // Обработчик фильрта имени
    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      
      setStates(
        typeof value === 'string' ? value.split(',') : value,
      );
      if (checkedThree) setFilterName({status: typeof value === 'string' ? value.split(',') : value});
    };

    // Состояние сворачивающегося меню с фильтрами
    const [expanded, setExpanded] = useState(false);
    // Обработчик состояния меню фильтров
    const handleExpansion = () => {
      setExpanded((prevExpanded) => !prevExpanded);
    };

    // состояние снэка с уведомлениями
    const [open, setOpen] = useState(false);
    // Обработчик снека
    // @ts-ignore
    const handleCloseSnack = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };

    // Ссылка на фильтр статуса
    let statusRef = useRef('');

    // Чекеры на активацию фильтров
    const [checked, setChecked] = useState(false);
    useEffect(() => {
      if (!checked) {setFilterName({name:''})}
    }, [checked]); 
    const [checkedTwo, setCheckedTwo] = useState(false);
    const [checkedThree, setCheckedThree] = useState(false);
    const [checkedFour, setCheckedFour] = useState(false);
    return (
      <div style={{
        width: '98%',
        margin: "1% 1% 0% 1%",
        height:'5%'
    }}>
      <div
        style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between"}}
      >
        <div style={{ height: "100%", display: 'flex', alignItems: "center "}}>
          <ClassicSearch setChecked={setChecked} setFilter={(val) => {setFilterName({name:val})}} checked={checked}/>
        </div>
        <div style={{display: 'flex', flexDirection: "row", alignItems: "center"}}>
          { 
            ds.items.map((el, index) => {
              if (index>0) {
                const FormatterComponent = el.formatter;
                return (
                  <div style={{ marginLeft: "10px" }} key={index}>
                  {/* Рендерим как компонент через JSX */}
                  <FormatterComponent
                    setListItems={setListItems}
                    setEmitFlag={setEmitFlag}
                    listItems={listItems}
                    listTables={listTables}
                    setListTables={setListTables}
                    setListTabs={setListTabs}
                    listTabs={listTabs}
                  />
                </div>
                  
                )
              }
              return null;
            })
          }
        </div>
        
      </div>
    </div>
    )
  }


  function Multilist({vars, onSelect}) {
    console.log("Multilist", vars)
    const [selected, setSelected] = useState([])

    const handleChange = (event) => {
      // console.log("RDL", event.target.value)
      onSelect(event.target.value)
      setSelected(event.target.value)
    };


    useEffect(() => {
      setSelected([])
    }, [vars]);

    return (
      <div>
        <FormControl sx={{width: "100%", marginBottom: "10px"}}>
          <Select
            multiple
            value={selected}
            onChange={handleChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            style={{
                borderRadius: "15px",
                fontSize: "15px",
                marginRight: "2px",
                height: "40px"
            }}
            renderValue={(selected) => selected.map((el) => el.title).join(', ')}
          >
            {vars.map((el) => (
              <MenuItem key={el.id} value={el}>
                <Checkbox checked={selected.findIndex((item) => el.id === item.id)>-1} />
                <Typography variant="body1">
                  {el.title}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    )
  }

  
  // @ts-ignore
  export function SwapBoxDialog({setListItems, setEmitFlag, listItems}){
    
    const [deals, setDeals] = useState([])
    const [clients, setClients] = useState([])
    const [market, setMarket] = useState(undefined)
    const [client, setClient] = useState(undefined)
    const [fromDeal, setFromDeal] = useState(undefined)
    const [toDeal, setToDeal] = useState(undefined)
    const [boxList, setBoxList] = useState([])
    const [selBoxList, setSelBoxList] = useState([])
    // Состояние открытия окна
    const [open, setOpen] = useState(false);
    // Обработчик открытия окна
    const DialoghandleClickOpen = () => {
      let tmp = []
      for (let i of Object.keys(listItems.items)) {
        for (let j of Object.keys(listItems.items[i])) {
          let idx = tmp.findIndex((el) => el.val === listItems.items[i][j].content.user_id)
          if (idx === -1) {
            tmp.push(
              {
                val: listItems.items[i][j].content.user_id,
                title: listItems.items[i][j].name,
              }
            )
          }
        }
      }
      setClients(tmp)
      setOpen(true);
    };
    // Обработчик закрытия окна
    const DialoghandleClose = () => {
      setOpen(false);
      setClient(undefined)
      setFromDeal(undefined)
      setToDeal(undefined)
    };


    const changeClient = async (v) => {
      console.log(v)
      if (!client || v.val !== client.val) {
        let tmp = []
        for (let i of Object.keys(listItems.items)) {
          for (let j of Object.keys(listItems.items[i])) {
            if (listItems.items[i][j].content.user_id === v.val && listItems.items[i][j].market === market) {
              tmp.push(listItems.items[i][j])
            }
          }
        }
        setDeals(tmp)
        setClient(v)
        setFromDeal(undefined)
        setToDeal(undefined)
      }
    }

    const changeMarket = async (v) => {
      console.log(v)
      if (v !== market) {
        let tmp = []
        for (let i of Object.keys(listItems.items)) {
          for (let j of Object.keys(listItems.items[i])) {
            if (client && listItems.items[i][j].content.user_id === client.val && listItems.items[i][j].market === v) {
              tmp.push(listItems.items[i][j])
            }
          }
        }
        setDeals(tmp)
        setMarket(v)
        setFromDeal(undefined)
        setToDeal(undefined)
      }
    }

    const changeFromDeal = async (v) => {
        if (v !== fromDeal) {
            const resp = await get("Boxes/GetOnDeal", { did: v });
            const regex = /([0-9]+)$/;

            const sortedResp = resp.sort((a, b) => {
                const numA = a.title.match(regex) ? parseInt(a.title.match(regex)[1]) : 0;
                const numB = b.title.match(regex) ? parseInt(b.title.match(regex)[1]) : 0;
                return numA - numB;
            });

            setBoxList(sortedResp);
            setSelBoxList([]);
            setFromDeal(v);
        }
    }
  
    const { showNotification } = useLocalNotifications();

    const SwapProduct = async () => {
      console.log("all good", fromDeal, selBoxList, toDeal)
      if (!fromDeal) {
        showNotification({
          id: 'sbd1', 
          type: 'error', 
          message: 'Не выбрана исходная сделка' 
        });
        return 0
      }
      if (!toDeal) {
        showNotification({
          id: 'sbd2', 
          type: 'error', 
          message: 'Не выбрана конечная сделка' 
        });
        return 0
      }
      if (selBoxList.length === 0) {
        showNotification({
          id: 'sbd3', 
          type: 'error', 
          message: 'Не выбраны короба' 
        });
        return 0
      }
      if (fromDeal === toDeal) {
        showNotification({
          id: 'sbd4', 
          type: 'error', 
          message: 'Изначальная и конечная сделки не могут быть одинаковыми' 
        });
        return 0
      }
      let fromDealNullBoxProducts = await get("products/GetProductOnDealOnBox", {bid:0, did:fromDeal})
      console.log("fromDealNullBoxProducts", fromDealNullBoxProducts)
      let tmp = [...boxList]
      let dlist = []
      await Promise.all(selBoxList.map(async (box) => {
        let resp = await get("products/GetProductsOnBox", {bid:box.id})
        await Promise.all(resp.map(async (prod) => {
          await post("products/update", {id:prod.id, deal_id:toDeal, countEtimated: 0})
          let idx = fromDealNullBoxProducts.findIndex((fel) => fel.nmID === prod.nmID && fel.size.barcode === prod.size.barcode)
          if (prod.countEtimated > 0) {
            if (idx > -1) {
              await post("products/update", {id:fromDealNullBoxProducts[idx].id, countEtimated:fromDealNullBoxProducts[idx].countEtimated+prod.countEtimated})
            }
            else {
              await post("products/copy", {id:prod.id, box_id:0, deal_id:fromDeal, countProduct:0, countEtimated:prod.countEtimated})
            }
          }
        }))
        await post("Boxes/update", {id:box.id, deal_id:toDeal})
        post("Deal/recalcProducts", {did:fromDeal})
        post("Deal/recalcProducts", {did:toDeal})
        dlist.push(box.id)
      }))
      // await post("Boxes/delete", {bid:dlist})
      setBoxList(tmp.filter((el) => !dlist.includes(el.id)))
      showNotification({
        id: 'sbd4', 
        type: 'success', 
        message: 'Перенос завершен' 
      });
      setSelBoxList([])
    }

    return(
      <div
      style={{display: 'inline-block', marginLeft: 'auto', marginRight: 0}}
      >
        <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold'}} onClick={DialoghandleClickOpen}>Переместить товар</Button>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "20px", maxWidth:'1700px'} }}
        >
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width:"30vw", height: "30vh", marginLeft:"15px", marginTop:"15px"}}>
            <div style={{width: "35%"}}>
              <SelectMarketLocal markets={['wb', 'ozon']} market={market} save={changeMarket}></SelectMarketLocal>
              <Typography variant="body1" style={{marginLeft:"5px"}}>Клиент</Typography>
              <FormControl sx={{width: "100%", marginBottom: "10px"}}>
                <Select
                    value={client}
                    onChange={(e) => {changeClient(e.target.value)}}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    style={{
                        borderRadius: "15px",
                        fontSize: "15px",
                        marginRight: "2px",
                        height: "40px"
                    }}
                    // renderValue={(value) => value?.title || ""}
                >
                    {clients.map((el, i) => (
                        <MenuItem key={i} value={el}> 
                          <Typography variant="body1">
                            {`${el.val} - ${el.title}`}
                          </Typography>
                        </MenuItem>
                    ))}
                </Select>
              </FormControl>
              {/* Сделка */}
              <Typography variant="body1" style={{marginLeft:"5px"}}>Исходная сделка</Typography>
              <FormControl sx={{width: "100%", marginBottom: "10px"}}>
                <Select
                    value={fromDeal}
                    onChange={(e) => {changeFromDeal(e.target.value)}}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    style={{
                        borderRadius: "15px",
                        fontSize: "15px",
                        marginRight: "2px",
                        height: "40px"
                    }}
                >
                    {deals.map((el, i) => (
                        <MenuItem key={i} value={el.id}> 
                          <Typography variant="body1">
                            Сделка № {el.cdn}
                          </Typography>
                        </MenuItem>
                    ))}
                </Select>
              </FormControl>
              {/* короба */}
              <Typography variant="body1" style={{marginLeft:"5px"}}>Короба</Typography>
              <Multilist vars={boxList} onSelect={setSelBoxList}/>
            </div>
            <div style={{ display:"flex", alignItems:"center", marginBottom: "15px"}}>
                <Divider orientation="vertical" sx={{ borderRightWidth: "3px", height:"100%" }} />
            </div>
            <div style={{width: "35%", marginRight: "15px", display: 'flex', flexDirection: "column", alignItems: "flex-end", justifyContent: "space-between"}}>
              {/* Сделка */}
              <div style={{width: "100%"}}>
                <Typography variant="body1" style={{marginLeft:"5px"}}>Конечная сделка</Typography>
                <FormControl sx={{width: "100%", marginBottom: "10px"}}>
                  <Select
                      value={toDeal}
                      onChange={(e) => {setToDeal(e.target.value)}}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      style={{
                          borderRadius: "15px",
                          fontSize: "15px",
                          marginRight: "2px",
                          height: "40px"
                      }}
                  >
                      {deals.map((el, i) => (
                          <MenuItem key={i} value={el.id}> 
                            <Typography variant="body1">
                              Сделка № {el.cdn}
                            </Typography>
                          </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
              <div style={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', marginBottom: "15px"}} onClick={SwapProduct}>Переместить</Button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }


  export function GenerateTableDialogStorage({setListItems, setEmitFlag, listItems}) {
    return <GenerateTableDialog setListItems={setListItems} setEmitFlag={setEmitFlag} listItems={listItems} hasUnity={true}/>
  }
  // @ts-ignore
  export function GenerateTableDialog({ setListItems, setEmitFlag, listItems, hasUnity = false }){
    
    const [deals, setDeals] = useState([])
    const [clients, setClients] = useState([])
    const [market, setMarket] = useState(undefined)
    const [client, setClient] = useState(undefined)
    const [selDealList, setSelDealList] = useState([])
    // Состояние открытия окна
    const [open, setOpen] = useState(false);
    // Обработчик открытия окна
    const DialoghandleClickOpen = () => {
      let tmp = []
      for (let i of Object.keys(listItems.items)) {
        for (let j of Object.keys(listItems.items[i])) {
          let idx = tmp.findIndex((el) => el.val === listItems.items[i][j].content.user_id)
          if (idx === -1) {
            tmp.push(
              {
                val: listItems.items[i][j].content.user_id,
                title: listItems.items[i][j].name,
              }
            )
          }
        }
      }
      setClients(tmp)
      setOpen(true);
    };
    // Обработчик закрытия окна
    const DialoghandleClose = () => {
      setOpen(false);
      setClient(undefined)
    };


    const changeClient = async (v) => {
      console.log(v)
      if (!client || v.val !== client.val) {
        let tmp = []
        for (let i of Object.keys(listItems.items)) {
          for (let j of Object.keys(listItems.items[i])) {
            if (listItems.items[i][j].content.user_id === v.val && listItems.items[i][j].market === market) {
              if (hasUnity) {
                for (let deal of listItems.items[i][j].content.deals) {
                  tmp.push({id: deal.id, title:deal.cdn, name: v.title})
                }
              }
              else {
                tmp.push({...listItems.items[i][j], title:listItems.items[i][j].cdn})
              }              
            }
          }
        }
        setDeals(tmp)
        setClient(v)
      }
    }

    const changeMarket = async (v) => {
      console.log(v)
      if (v !== market) {
        let tmp = []
        for (let i of Object.keys(listItems.items)) {
          for (let j of Object.keys(listItems.items[i])) {
            if (client && listItems.items[i][j].content.user_id === client.val && listItems.items[i][j].market === v) {
              if (hasUnity) {
                for (let deal of listItems.items[i][j].content.deals) {
                  tmp.push({id: deal.id, title:deal.cdn, name: v.title})
                }
              }
              else {
                tmp.push({...listItems.items[i][j], title:listItems.items[i][j].cdn})
              }
            }
          }
        }
        setDeals(tmp)
        setMarket(v)
      }
    }
  
    

    const DownloadTable = async (event) => {
      console.log("seldeals", selDealList)
      if (event) {
          event.preventDefault(); // Предотвращаем действие по умолчанию
          event.stopPropagation(); // Останавливаем всплытие события
      }
      if (selDealList.length > 0) {
        // 1. Создаем новую книгу и лист
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        const DataArray = []; // Ваши данные здесь

        // 2. Определяем заголовки столбцов
        let headers = [
            { header: 'Поставщик', key: 'vendor'},
            { header: 'Наименование товара', key: 'name'},
            { header: 'Баркод', key: 'barcode'},
            { header: 'Техническое задание', key: 'techTask'},
            { header: 'Количество', key: 'count'},
        ];
        let c = 1
        let dids = []
        let vendor = selDealList[0].name
        for (let d of selDealList) {
          dids.push(d.id)
        }


        let DealsInfo = await get("Deal/getDealsInfoForTable", {deals:dids})
        console.log("DealsInfo", DealsInfo)

        let shipmentPlaceHeaders = []

        for (let d of DealsInfo) {
          if (d.warehouse_market && shipmentPlaceHeaders.findIndex((hel) => hel.header === d.warehouse_market) === -1) {
            shipmentPlaceHeaders.push({ header: d.warehouse_market, key: `wm_${c}`})  
            c++
          }
        }

        headers = headers.concat(shipmentPlaceHeaders)
        // headers.push({ header: "Не указано", key: `sp_0`})
        worksheet.columns = headers
        
        // 2.5. Стилизация заголовков
        worksheet.getRow(1).eachCell((cell, colNumber) => {
            // Устанавливаем стиль для заголовков
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFFFF' }
            };
            
            // Пастельные цвета для заголовков с sp_ и остальных
            const headerKey = headers[colNumber - 1].key;
            
            if (headerKey.startsWith('sp_')) {
                // Пастельный желтый для sp_ заголовков
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFFACD' } // Лимонный шифон (пастельный желтый)
                };
            } else {
                // Пастельный голубой для остальных заголовков
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFE0FFFF' } // Бирюзовый (пастельный голубой)
                };
            }
            
            // Общие стили для всех заголовков
            cell.font = {
                bold: true,
                size: 12,
                color: { argb: 'FF000000' }
            };
            cell.border = {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            };
            cell.alignment = {
                vertical: 'middle',
                horizontal: 'center',
                wrapText: true // Автоперенос текста
            };
        });

        // 3. Добавляем данные (пример с массивом объектов)
        // Предположим, что `data` - это массив объектов вида {id: 1, name: "Товар 1", quantity: 5}

        for (let p of DealsInfo) {
          let idx = DataArray.findIndex((el) => el.barcode === p.barcode && el.techTask === p.techTask)
          if (idx === -1) {
            let obj = {
              barcode: p.barcode,
              vendor,
              count: p.count,
              techTask: p.techTask,
              name: p.name
            }
            if (p.warehouse_market) {
              shipmentPlaceHeaders.map((sph) => {
                if (p.warehouse_market === sph.header) obj[sph.key] = p.count 
                else obj[sph.key] = ""
              })
            }
            else{
              shipmentPlaceHeaders.map((sph) => {obj[sph.key] = ""})
            }
            
            DataArray.push(obj)
          }
          else {
            DataArray[idx].count += p.count
            if (p.warehouse_market) {
              shipmentPlaceHeaders.map((sph) => {
                if (p.warehouse_market === sph.header) DataArray[idx][sph.key] += p.count 
              })
            }
          }
        }

        worksheet.addRows(DataArray);

        // 5. Настраиваем ширину столбцов
        worksheet.columns.forEach((column, index) => {
            let maxLength = 0;
            
            // Получаем длину заголовка
            const header = headers[index].header;
            const headerLength = header ? header.toString().length : 0;
            maxLength = headerLength;
            
            // Получаем максимальную длину значения в столбце
            worksheet.getColumn(index + 1).eachCell({ includeEmpty: true }, (cell) => {
                if (cell.value) {
                    const cellLength = cell.value.toString().length;
                    if (cellLength > maxLength) {
                        maxLength = cellLength;
                    }
                }
            });
            
            // Устанавливаем ширину с небольшим запасом
            // Минимальная ширина - по заголовку, максимальная - 50 символов
            const columnWidth = Math.min(Math.max(maxLength + 2, headerLength + 2), 50);
            column.width = columnWidth;
        });

        // 6. Применяем стили к данным
        worksheet.eachRow((tableRow, rowNumber) => {
            if (rowNumber > 1) { // Пропускаем заголовки
                // @ts-ignore
                tableRow.eachCell((cell, colNumber) => {
                    // Стили для данных
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'left',
                        wrapText: true // Автоперенос текста в ячейках с данными
                    };
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                        left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                        bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                        right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
                    };
                    cell.font = {
                        size: 11
                    };
                });
            }

        });

        // 7. Замораживаем строку с заголовками
        worksheet.views = [
            { state: 'frozen', ySplit: 1 }
        ];
        // 8. Генерируем файл как буфер
        const buffer = await workbook.xlsx.writeBuffer();

        // 9. Создаем Blob и скачиваем файл
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // saveAs(blob, 'МойФайл.xlsx');
        

        const blobUrl = URL.createObjectURL(blob);

        // Открываем новую вкладку с Blob-URL
        const newTab = window.open(blobUrl, '_blank');

        // Пытаемся закрыть вкладку через короткую задержку (может быть заблокировано браузером)
        if (newTab) {
            setTimeout(() => {
                try {
                    newTab.close();
                    console.log('Вкладка для скачивания закрыта.');
                } catch (e) {
                    // Скорее всего, браузер запретил скрипту закрыть вкладку
                    console.log('Файл открыт в новой вкладке. Пользователь может закрыть ее вручную.');
                }
            }, 1000); // Задержка 1 секунда
        } else {
            // Если браузер заблокировал открытие новой вкладки, предлагаем скачать файл стандартным способом
            alert('Браузер заблокировал открытие в новой вкладке. Файл будет скачан.');
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'Распределение_товара.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        // Всегда освобождаем память от Blob-URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      }
    }

    return(
      <div
      style={{display: 'inline-block', marginLeft: 'auto', marginRight: 0}}
      >
        <Button variant="contained" disabled={Object.keys(listItems.items).length === 0} sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', borderRadius: "10px"}} onClick={DialoghandleClickOpen}>Таблица сделок</Button>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "20px", maxWidth:'1700px'} }}
        >
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width:"30vw", height: "30vh", marginLeft:"15px", marginTop:"15px"}}>
            <div style={{width: "35%"}}>
              <SelectMarketLocal markets={['wb', 'ozon', 'custom']} market={market} save={changeMarket}></SelectMarketLocal>
              <Typography variant="body1" style={{marginLeft:"5px"}}>Клиент</Typography>
              <FormControl sx={{width: "100%", marginBottom: "10px"}}>
                <Select
                    value={client}
                    onChange={(e) => {changeClient(e.target.value)}}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    style={{
                        borderRadius: "15px",
                        fontSize: "15px",
                        marginRight: "2px",
                        height: "40px"
                    }}
                    // renderValue={(value) => value?.title || ""}
                >
                    {clients.map((el, i) => (
                        <MenuItem key={i} value={el}> 
                          <Typography variant="body1">
                            {`${el.val} - ${el.title}`}
                          </Typography>
                        </MenuItem>
                    ))}
                </Select>
              </FormControl>
              {/* Сделки */}
              <Multilist vars={deals} onSelect={setSelDealList}/>
            </div>
            <div style={{ display:"flex", alignItems:"center", marginBottom: "15px"}}>
                <Divider orientation="vertical" sx={{ borderRightWidth: "3px", height:"100%" }} />
            </div>
            <div style={{width: "35%", marginRight: "15px", display: 'flex', flexDirection: "column", alignItems: "flex-end", justifyContent: "space-between"}}>
              <div style={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', marginBottom: "15px"}} onClick={DownloadTable}>Скачать таблицу</Button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }

  export function ClientInfoBox(data) {
    //console.log('DND DATA', data)
    const value = data?.listItems?.items;

    //console.log('DND VALUE', value)
    let totalClients = data?.listItems?.order?.length || 0

    const stats = useMemo(() => {
      let totalDeals = 0;

      if (!value) return {deals: 0 };

      Object.values(value).forEach(innerGroup => {
        if (innerGroup && typeof innerGroup === 'object') {
          Object.values(innerGroup).forEach(item => {
            totalDeals += item?.dealcount || 0;
          });
        }
      });

      return {
        deals: totalDeals
      };
    }, [value]);

    return (
      <div style={{ display: 'flex', alignItems: 'center', height: "36px"}}>

              <Box 
                sx={{
                  zIndex: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'rgba(255, 255, 255, 0.5)',
                  padding: '15px 20px',
                  borderRadius: '10px',
                  minWidth: '250px',
                  height: '100%', 
                  justifyContent: 'center'
                }}
              >
                <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexDirection: "row"}}>
                  <Typography sx={{ fontSize: '11pt' }}>
                      Количество клиентов: {totalClients}
                  </Typography>
                  <Typography sx={{ fontSize: '11pt' }}>
                      Кол-во сделок: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{stats.deals} шт.</Typography>
                  </Typography>
                </Box>
              </Box>
      </div>
    //   // <Typography>
    //   //   SKU: {stats.sku}, кол-во товаров: {stats.units}, Сделок: {stats.deals}
    //   // </Typography>
    );
  }

  export function DealsInfoBox(data ) {
    //console.log('DND DATA', data)
    const value = data?.listItems?.items;

    //console.log('DND VALUE', value)

    const stats = useMemo(() => {
      let totalSku = 0;
      let totalUnits = 0;
      let totalDeals = 0;

      if (!value) return { sku: 0, units: 0, deals: 0 };

      Object.values(value).forEach(innerGroup => {
        if (innerGroup && typeof innerGroup === 'object') {
          Object.values(innerGroup).forEach(item => {
            totalDeals++;
            totalSku += item.content?.sku || 0;
            totalUnits += item.content?.units || 0;
          });
        }
      });

      return {
        sku: totalSku,
        units: totalUnits,
        deals: totalDeals
      };
    }, [value]);

    return (
      <div style={{ display: 'flex', alignItems: 'center', height: "36px"}}>

              <Box 
                sx={{
                  zIndex: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'rgba(255, 255, 255, 0.5)',
                  padding: '15px 20px',
                  borderRadius: '10px',
                  minWidth: '250px',
                  height: '100%', 
                  justifyContent: 'center'
                }}
              >
                <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexDirection: "row"}}>
                  <Typography sx={{ fontSize: '11pt' }}>
                      Кол-во сделок: {stats.deals}
                  </Typography>
                  <Typography sx={{ fontSize: '11pt' }}>
                      Кол-во товаров: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{stats.units} шт.</Typography>
                  </Typography>
                  <Typography sx={{ fontSize: '11pt' }}>
                      SKU: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{stats.sku} шт.</Typography>
                  </Typography>
                </Box>
              </Box>
      </div>
      // <Typography>
      //   SKU: {stats.sku}, кол-во товаров: {stats.units}, Сделок: {stats.deals}
      // </Typography>
    );
  }

  export function AddrInfoBox(data ) {
    console.log('ADDR DATA', data)
    const value = data

    console.log('ADDR VALUE', value)

    const stats = useMemo(() => {
      const totalTabs = value?.listTabs.length || 0;
      const totalTables = value?.listTables.length || 0
      const totalItems = value?.listTables.reduce((sum, table) => {
        return sum + (table.items?.length || 0);
      }, 0);

      return {
        tabs: totalTabs,
        tables: totalTables,
        items: totalItems
      };
    }, [value]);

    return (
      <div style={{ display: 'flex', alignItems: 'center', height: "36px"}}>

              <Box 
                sx={{
                  zIndex: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'rgba(255, 255, 255, 0.5)',
                  padding: '15px 20px',
                  borderRadius: '10px',
                  minWidth: '250px',
                  height: '100%', 
                  justifyContent: 'center'
                }}
              >
                <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexDirection: "row"}}>
                  <Typography sx={{ fontSize: '11pt' }}>
                      Количество стеллажей: {stats.tabs}
                  </Typography>
                  <Typography sx={{ fontSize: '11pt' }}>
                      Количество секций: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{stats.tables}</Typography>
                  </Typography>
                  <Typography sx={{ fontSize: '11pt' }}>
                      Количество ячеек: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{stats.items}</Typography>
                  </Typography>
                </Box>
              </Box>
      </div>
    );
  }

  // Диалоговое окно с поставками в виде календаря
  // @ts-ignore
  export function AddGoodTicketDialog({setListItems, setEmitFlag, listItems}){
    // Состояние открытия окна
    const [open, setOpen] = useState(false);
    // Обработчик открытия окна
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
    // Обработчик закрытия окна
    const DialoghandleClose = () => {
      setOpen(false);
    };

    // Создание каллендаря для отображения
    const createCalendar = (selectMonth) => {
      const startDate = selectMonth.clone().startOf('month').startOf('week');
      const endDate = selectMonth.clone().endOf('month').endOf('week');
      const day = startDate.clone();
      const weeklyMass = []
      let buffmass = [];
      while(!day.isAfter(endDate)){
        buffmass = [];
        for (let i = 0; i < 7; i++){
          buffmass.push(day.clone());
          day.add(1, 'day');
        }
        weeklyMass.push(buffmass);
      }
      return weeklyMass;
    }
    // Период для отображения
    const [period, setPeriod] = useState(3);
    // Чекер на период
    const [checked, setChecked] = useState(1);

    // Календарь
    const [weeklyMass, setWeeklyMass] = useState({selectMonth: moment(), dates:createCalendar(moment())});

    // Обработчик смены месяца для календаря
    const handleChangeMonth = (l) => {
      let buff = null;
      if (l === -1){
        buff = weeklyMass.selectMonth.clone().subtract(1, 'months').startOf('month');
        if (moment().isSame(buff, 'month'))
          buff = moment();
      }
      else{
        buff = weeklyMass.selectMonth.clone().add(1, 'months').startOf('month');
        if (moment().isSame(buff, 'month'))
          buff = moment();
      }
      setWeeklyMass({selectMonth: buff, dates:createCalendar(buff)});
    }
  
    return(
      <div
      style={{display: 'inline-block', marginLeft: 'auto', marginRight: 0}}
      >
        <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold'}} onClick={DialoghandleClickOpen}>Новая сделка</Button>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "20px", maxWidth:'1700px'} }}
        >
          <div>
            <div
              style={{height:'40px', marginTop:'20px', marginLeft:'15px', display:'flex', marginBottom:'20px', justifyContent:'center', alignItems:'center', alignContent:'center'}}
            >
              <div style={{userSelect: 'none', display: 'flex', justifyContent:'center', alignItems:'center', alignContent:'center', height:'100%'}}>
                <div style={{userSelect: 'none', display: 'inline-block'}}>
                  <IconButton aria-label="back" style={{height:'24px', width:'24px', display: "flex"}} onClick={() => {handleChangeMonth(-1)}}>
                    <ArrowBackIosNewIcon style={{fontSize:'12px'}}/>
                  </IconButton>
                </div>
                <div>
                  <p style={{textTransform: 'capitalize', display:'inline-block', textAlign: 'center', lineHeight:'100%', width:'115px'}}>{weeklyMass.selectMonth.format('MMMM, YYYY')}</p>
                </div>
                <div style={{userSelect: 'none', display: 'inline-block'}}>
                  <IconButton aria-label="next" style={{height:'24px', width:'24px', display: "flex"}} onClick={() => {handleChangeMonth(1)}}>
                    <ArrowForwardIosIcon style={{fontSize:'12px'}}/>
                  </IconButton>
                </div>
              </div>
              <div style={{userSelect: 'none', display: 'inline-block'}}>
                <TabsRadio
                  checked={checked}
                  handleChange={(e)=> {setChecked(+e.target.value);}}
                  value={1}
                  name={'Приёмка'}
                />
                <TabsRadio
                  checked={checked}
                  handleChange={(e)=> {setChecked(+e.target.value);}}
                  value={2}
                  name={'Отгрузка'}
                />
              </div>
              <div
                style={{marginLeft:'auto', marginRight:'15px', display: 'inline-block'}}
              >
                <TabsRadio
                  checked={period}
                  handleChange={(e)=> {setPeriod(+e.target.value);}}
                  value={3}
                  name={'Месяц'}
                />
                <TabsRadio
                  checked={period}
                  handleChange={(e)=> {setPeriod(+e.target.value);}}
                  value={4}
                  name={'Неделя'}
                />
              </div>
            </div>
            {period === 3 ? <MonthlyCalendar dateMass={weeklyMass}/>
            : <WeeklyCalendar dateMass={weeklyMass}/>}
          </div>
        </Dialog>
      </div>
    )
  }
  
  // Компонент календаря по месяцам
  export const MonthlyCalendar = ({dateMass}) => {
    return(
      <div>
        <Scrollbars
          autoHeight autoHeightMax={827}
        >
        <div style={{borderLeft:'1px solid gray', border:'.5px solid #C0C0C0', margin:'10px', marginBottom:'25px'}}>
        {dateMass.dates[0].map((item, index) => {return(
          <div key={`dayofweek${index}`} style={{height:'40px', width:'145px', display: 'inline-block', border:'.5px solid #C0C0C0', padding:'5px'}}>
            <p style={{textTransform: 'capitalize', fontSize: '18px', fontWeight:'bold'}}>{item.format('dd')}</p>
          </div>
        )})}
        {dateMass.dates.map((oneitem, index) => {
          return (
            <div key={`daterow${index}`} style={{display:'table'}}>
              {oneitem.map((item, index) => {
                return (
                  <div key={`datecol${index}`} style={{ height:'150px', width:'145px', display: 'table-cell', border: item.isSame(moment(), 'day') ? '3px solid #078376' : '.5px solid #C0C0C0'/*, borderBottom:'1px solid #C0C0C0'*/, padding:'5px'}}>
                    <p style={{margin:'0', lineHeight:'100%', color:item.isSame(dateMass.selectMonth, 'month') ? item.isSame(moment(), 'day') ? '#078376' : 'black' : '#C0C0C0'}}>{item.format('D')}</p>
                    {item.isSame(moment(), 'day') ? <CalendarMonthInfo
                        name={'Отгрузка'}
                        count={10}
                        box={40}
                        goods={200}
                        pallet={10}
                        collor={'rgba(255, 140, 0, 0.4)'}
                        dotcollor={'#FF8C00'}
                      />
                    :<></>}
                  </div>
                )})}
            </div>
        );})}
        </div>
        </Scrollbars>
      </div>
    )
  }

  // Компонент календаря по неделям
  export const WeeklyCalendar = ({dateMass}) => {
    const [week, setWeek] = useState(dateMass.dates.findIndex(item => ~item.findIndex(el => el.isSame(moment(), 'day'))));
    useEffect(()=>{
      setWeek(dateMass.dates.findIndex(item => ~item.findIndex(el => el.isSame(moment(), 'day'))))
    }, [dateMass])
    return(
      <div style={{userSelect: 'none', display: 'flex', justifyContent:'center', alignItems:'center', alignContent:'center'}}>
        <div style={{display:'inline-block'}}>
          <IconButton aria-label="back" size="large"  onClick={() => {if (week > 0) setWeek(week - 1)}}>
            <ArrowBackIosNewIcon fontSize='inherit'/>
          </IconButton>
        </div>
        <div style={{borderLeft:'1px solid gray', border:'.5px solid #C0C0C0', margin:'10px', marginBottom:'25px', display:'inline-block'}}>
        <Scrollbars
          autoHeight autoHeightMax={610}
        >
        <div style={{display:'table', minHeight:'190px'}}>
        {dateMass.dates[week===-1 ? 0 : week].map((item, index) => {
          return (
            <div key={`datecol${index}`} style={{/*maxHeight:'150px', minHeight:'50px'*/ minHeight:'190px', minWidth:'145px', display: 'table-cell', border:item.isSame(moment(), 'day') ? '3px solid #078376' : '.5px solid #C0C0C0'}}>
            <div key={`dayofweek${index}`} style={{height:'40px', width:'143px', display: 'inline-block', padding:'5px', borderBottom:'2px solid #C0C0C0'}}>
              <p style={{textTransform: 'capitalize', fontSize: '18px', fontWeight:'bold', color:item.isSame(dateMass.selectMonth, 'month') ? item.isSame(moment(), 'day') ? '#078376' : 'black' : '#C0C0C0'}}>{item.format('dd, D')}</p>
            </div>
              {// Тут для отображения нужно распарсить массив с поставками. Пока не известно как он будет выглядтеть, сделан тестовый вариант
              item.isSame(moment(), 'day') ? <><CalendarWeekInfo
                name={'Вб тест'} 
                box={40}
                goods={200}
                pallet={10}
                company={wb}
              />
              <CalendarWeekInfo
                name={'Озон тест'} 
                box={20}
                goods={150}
                pallet={11}
                company={ozon}
              />
              <CalendarWeekInfo
                name={'Озон тест1'} 
                box={20}
                goods={150}
                pallet={11}
                company={ozon}
              />
              <CalendarWeekInfo
                name={'Озон тест2'} 
                box={20}
                goods={150}
                pallet={11}
                company={ozon}
              />
              <CalendarWeekInfo
                name={'Озон тест3'} 
                box={20}
                goods={150}
                pallet={11}
                company={ozon}
              />
              </>
            :<></>}
            </div>
          )})}
          </div>
          </Scrollbars>
        </div>
        <div style={{display:'inline-block'}}>
          <IconButton aria-label="next" size="large" onClick={() => {if (week < dateMass.dates.length - 1) setWeek(week + 1)}}>
            <ArrowForwardIosIcon fontSize='inherit'/>
          </IconButton>
        </div>
      </div>
    )
  }

  // Ячейка недельного календаря
  const CalendarWeekInfo = ({name, box, goods, pallet, company}) => {
    return (
      <div style={{height:'160px', width:'143px', borderTop:'1px solid #C0C0C0', padding:'7px'}}>

        <div style={{display: 'flex',  alignItems:'center', alignContent:'center',}}>
          <img src={company} alt="Company" style={{ height: '20px', width:'20px', borderRadius:'5px', display:'inline-block'}}></img><Typography noWrap style={{marginLeft:'4px', textAlign: 'center', lineHeight:'100%', display:'inline-block', fontSize: '14px', color:'#686868'}}>{name}</Typography>
        </div>

        <div style={{marginTop:'10px'}}>
          <div style={{display: 'flex',  alignItems:'center', alignContent:'center'}}>
            <div style={{display:'inline-block', height:'5px', width:'5px', borderRadius:'50%', backgroundColor:'#00BFFF'}}></div><Typography noWrap style={{display:'inline-block', marginLeft:'4px', lineHeight:'100%', fontSize: '16px', fontWeight:'bold', color:'#686868'}}>{box}</Typography>
          </div>
          <Typography noWrap style={{marginLeft:'10px', lineHeight:'100%', fontSize: '14px', color:'#888888'}}>коробов</Typography>
        </div>

        <div style={{marginTop:'10px'}}>
          <div style={{display: 'flex',  alignItems:'center', alignContent:'center'}}>
            <div style={{display:'inline-block', height:'5px', width:'5px', borderRadius:'50%', backgroundColor:'#3CB371'}}></div><Typography noWrap style={{display:'inline-block', marginLeft:'4px', lineHeight:'100%', fontSize: '16px', fontWeight:'bold', color:'#686868'}}>{goods}</Typography>
          </div>
          <Typography noWrap style={{marginLeft:'10px', lineHeight:'100%', fontSize: '14px', color:'#888888'}}>товаров</Typography>
        </div>

        <div style={{marginTop:'10px'}}>
          <div style={{display: 'flex',  alignItems:'center', alignContent:'center'}}>
            <div style={{display:'inline-block', height:'5px', width:'5px', borderRadius:'50%', backgroundColor:'#FF8C00'}}></div><Typography noWrap style={{display:'inline-block', marginLeft:'4px', lineHeight:'100%', fontSize: '16px', fontWeight:'bold', color:'#686868'}}>{pallet}</Typography>
          </div>
          <Typography noWrap style={{marginLeft:'10px', lineHeight:'100%', fontSize: '14px', color:'#888888'}}>монопаллет</Typography>
        </div>
      </div>
    )
  }

  // Ячейка месячного календаря
  const CalendarMonthInfo = ({name, count, box, goods, pallet, collor, dotcollor}) => {
    return (
      <div style={{height:'80px', width:'128px', padding:'7px'}}>

        <div style={{marginTop:'2px'}}>
          <div style={{display: 'flex',  alignItems:'center', alignContent:'center', backgroundColor:`${collor}`, borderRadius:'4px'}}>
            <div style={{display:'inline-block', height:'5px', width:'5px', borderRadius:'50%', backgroundColor:`${dotcollor}`, marginLeft:'4px'}}></div><Typography noWrap style={{display:'inline-block', marginLeft:'4px', lineHeight:'100%', fontSize: '14px', fontWeight:'bold', color:'#686868'}}>{name}</Typography><Typography noWrap style={{marginLeft:'auto', marginRight:'4px', lineHeight:'100%', fontSize: '14px', color:'#686868', fontWeight:'bold'}}>{count}</Typography>
          </div>
          
        </div>

        <div style={{marginTop:'2px'}}>
          <div style={{display: 'flex',  alignItems:'center', alignContent:'center'}}>
            <Typography noWrap style={{marginLeft:'4px', lineHeight:'100%', fontSize: '14px', color:'#888888'}}>коробов</Typography><Typography noWrap style={{marginLeft:'auto', marginRight:'4px',display:'inline-block', lineHeight:'100%', fontSize: '14px', fontWeight:'bold', color:'#686868'}}>{box}</Typography>
          </div>
          
        </div>

        <div style={{marginTop:'2px'}}>
          <div style={{display: 'flex',  alignItems:'center', alignContent:'center'}}>
            <Typography noWrap style={{marginLeft:'4px', lineHeight:'100%', fontSize: '14px', color:'#888888'}}>товаров</Typography><Typography noWrap style={{marginLeft:'auto', marginRight:'4px',display:'inline-block', lineHeight:'100%', fontSize: '14px', fontWeight:'bold', color:'#686868'}}>{goods}</Typography>
          </div>
          
        </div>

        <div style={{marginTop:'2px'}}>
          <div style={{display: 'flex',  alignItems:'center', alignContent:'center'}}>
          <Typography noWrap style={{marginLeft:'4px', lineHeight:'100%', fontSize: '14px', color:'#888888'}}>паллет</Typography><Typography noWrap style={{marginLeft:'auto', marginRight:'4px',display:'inline-block', lineHeight:'100%', fontSize: '14px', fontWeight:'bold', color:'#686868'}}>{pallet}</Typography>
          </div>
        </div>
          
        </div>
    )
  }


  // Элемент меню для выбора чего либо на основе радиобаттонов
  export const TabsRadio = ({checked, handleChange, value, name}) => {
    return (
      <div style={{display: 'inline-block'}}>
        <label htmlFor={`radio-${value}`}
          style={{
            display: 'inline-block',
            cursor: 'pointer',
            padding: '0px 5px',
            lineHeight: '34px',
            borderBottom: checked === value ? '3px solid #078376' : '0px',
            color: checked === value ? 'primary' : '#686868',
            userSelect: 'none',
          }}
        >
          <input id={`radio-${value}`} type="radio" name="radio" value={`${value}`} onChange={handleChange} style={{display: 'none'}}/>
          {name}
        </label>
      </div>
    );
  }

  // Компонент верхней панели забора товара
  // @ts-ignore
  export const TopPanelPikUp = ({setFilterName, setListItems, setEmitFlag}) => {
    const [checked, setChecked] = useState(false);
    return (
      <div style={{
        width: '100%',
        height:'13%',
        maxHeight:'60%',
        backgroundColor:'white',
        padding: '20px',
        whiteSpace: 'nowrap', 
    }}>
      <div
      style={{ display: 'flex'}}
      >
        <Typography variant="body1" sx={{fontWeight: '800', fontSize: '24px', display: 'inline-block'}}>Забор товара</Typography>
      </div>
        <ClassicSearch setChecked={setChecked} setFilter={setFilterName} checked={checked}/>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
        <InputLabel htmlFor="grouped-select">Фильтр</InputLabel>
        <Select defaultValue="" id="grouped-select" label="Grouping" sx={{backgroundColor:'#e0e0e0', borderRadius: '7px', boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 }}}>
            <MenuItem value="">
                <em>None</em>
            </MenuItem>
            <MenuItem value={1}>Option 1</MenuItem>
            <MenuItem value={2}>Option 2</MenuItem>
            <MenuItem value={3}>Option 3</MenuItem>
            <MenuItem value={4}>Option 4</MenuItem>
        </Select>
        </FormControl>
        
    </div>
    )
  }
  

  // Диалоговое окно добавления контейнера с вложенностью
  export const EditNestedTableDialog = ({currentStatus = null, setListTables, listTables, oldname, oldcolor = '#e0e0e0', oldcolorcircule = '#e0e0e0', setEmitFlag, setListTabs, listTabs}) => {

    console.log("listTabs", listTabs)
    // Переменная имени нового контейнера
    // @ts-ignore
    const [name, setName] = useState(oldname ? oldname : null);
    // Переменная для количества вложенных контейнеров
    const [count, setCount] = useState(currentStatus ? listTables[listTables.findIndex(item => item.status === currentStatus)]?.items.length : null);
    // состояние окна
    const [open, setOpen] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    // @ts-ignore
    const [editMode, setEditMode] = useState(false)

    const { showNotification } = useLocalNotifications();

    // Обработчик открытия окна
    // @ts-ignore
    const DialoghandleClickOpen = () => {
      if (localStorage.getItem("AST")) {
        setOpen(true);
      }
      else {
        showNotification({
          id: 'notSelTab', // Уникальный идентификатор
          type: 'error', // Тип уведомления
          message: 'Стеллаж не выбран' // Текст сообщения
        });
      }
    };
    // Обработчик закрытия окна
    const DialoghandleClose = () => {
      setName(null);
      setColors({color:'#e0e0e0', colorcircule:'#e1e1e1'});
      setCount(null);
      setOpen(false);
    };
  
    // Обработчик добавления нового контейнера с вложенностью в массив контейнеров
    const DialoghandleAdd = () => {

      const find_void_num = (list) => {
        let actual = 1
        let c = 0
        let l = list.length
        while (c < l-1) {
          let n = parseInt(list[c+1].status.split('-')[1])
          if ( n === actual + 1) {
            actual +=1
          }
          c+=1
        }
        return actual +1
      }



      if (count && colors){ // Проверка на то что все поля заполнены
        var array = [...listTables];
        let tab = localStorage.getItem("AST")

        ////new status
        let st = listTabs.find((fel) => fel.name === tab)?.title
        let t = find_void_num(array.filter((fel) => fel.tab === tab))
        let new_status = `${st}-${t}`
        ///////

        var table = { name: new_status, status: new_status, color:colors.color, colorcircule:colors.colorcircule, items:[], tab}; // создание контейнера
        for (let i = 1; i <= count; i++) {
          table.items.push({name:i, status:`${new_status}_${i}`, color:colors.color, colorcircule:colors.colorcircule}) // Добавление контейнера в массив
        }
        array.push(table); 
        array = array.sort((a, b) => a.status.localeCompare(b.status))
        setEmitFlag(true);
        setListTables(array);// Сохранение массива
        DialoghandleClose();// Закрытие окна
      }
    };
  
    const handleInputChangeCount = (event) => {
        if (event.target.value === '') {
            setCount(0);
        }
        else {
            let tmp = parseInt(event.target.value, 10)
            if (!isNaN(tmp)) {
              if (tmp <= 20) {setCount(tmp);}
              else {setCount(20);}
            }
        }
    };

    // Массив стандартных цветов для создания
    const colorsmas = [
      {color:'#fffbbc', colorcircule:'#e8dd2f'},
      {color:'#c7d3ff', colorcircule:'#8ea5fd'},
      {color:'#ffb3b7', colorcircule:'#f87d83'},
      {color:'#fcc9ff', colorcircule:'#f79afc'},
      {color:'#b7f6b9', colorcircule:'#53f178'},
      {color:'#b2f4e3', colorcircule:'#7fecd1'},
      {color:'#ffd7a4', colorcircule:'#f2ba72'},
    ];
    // Переменная для цвета
    const [colors, setColors] = useState(oldcolor ? {color: oldcolor, colorcircule: oldcolorcircule} : {color:'#e0e0e0', colorcircule:'#e1e1e1'});
  
    return(
      <div style={{display: 'inline-block', marginLeft: 'auto', marginRight: 0}}>
        {/* <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', marginRight: "10px"}} onClick={DialoghandleClickOpen}>Добавить полку</Button> */}
        <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', marginRight: "10px", borderRadius: "10px"}} onClick={() => {setOpenSettings(true)}}>Настройки</Button>
        
        <Dialog
          open={openSettings}
          onClose={() => {setOpenSettings(false)}}
          PaperProps={{ sx: { borderRadius: "20px" } }}
          >
            <div
              style={{height:'420px', width:'600px'}}
            >
              <SettingsDialog
                open={openSettings}
                onClose={() => setOpenSettings(false)}
                listTabs={listTabs}
                setListTabs={setListTabs}
                listTables={listTables}
                setListTables={setListTables}
              />
            </div>
        </Dialog>

        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "20px" } }}
          >
            <div
              style={{height:'420px', width:'600px'}}
            >
              
              <div style = {{position: 'relative', paddingTop: '15px'}}>
                <div style = {{alignContent: 'center', alignItems: 'center'}}>
                    <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                        <Typography variant="body1" sx={{fontWeight: '800', 'font-size': '30px', display: 'row', marginTop:'20px'}}>Добавить полку</Typography>
                        {/* <TextField variant="filled" defaultValue={name} label="Название" onChange={(e) => {setName(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:colors.color, marginTop:'30px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: colors.color, borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField> */}
                        <TextField variant="filled" defaultValue={count} label="Количество полок" onChange={(e) => {handleInputChangeCount(e);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'30px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: '#e0e0e0', borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
                        <div style={{display:'flex', width:'70%', height:'60px', justifyContent:'space-between'}}>
                          {colorsmas.map((el, index)=> (
                            <div key={index} onClick={() => setColors(el)} style={{width:'40px', height:'40px', background:el.color, marginTop:'20px', borderRadius:'10px', cursor:'pointer'}}>
                            </div>
                          )) }
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'30px'}}>
                  <Button variant="contained" onClick={DialoghandleClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Отмена</Button>
                  <Button variant="contained" onClick={DialoghandleAdd} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Добавить</Button>
                </div>
              </div>
            </div>
        </Dialog>
      </div>
    )
  }

  const listItemSx = {
    display: "flex",
    alignItems: "center",
    marginLeft:'0px',
    borderRadius: "8px",
    transition: "0.2s",
    height: 44,
    color: "#838383",
    minWidth: 180,
    fontSize:'16pt',
  }

  const textWrapperSx = {
    px: 1.5,
    py: "2px",
    borderRadius: "6px",
    display: "inline-block",
    minWidth: 80,
    textAlign: "center",
    cursor: "pointer",

    "&:hover": {
      background: "#f5f5f5"
    }
  }

  const selectedTextSx = {
    background: "#bcdbde",
    color: "#f7fafb"
  }

  const itemLeftSx = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft:'42px',
    flex: 2,
    minWidth: 100,
    overflow: "hidden"
  }

  const itemRightSx = {
    display: "flex",
    alignItems: "center",
    marginRight:'-30px',
    minWidth: 100,
    justifyContent: "flex-end"
  }

  const columnSx = {
    width: "100%",
    minWidth: 150,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginLeft:'2px',
    p: 2,
    gap: 1,
    height: "100%",
    overflow: "hidden",
    overflowX: "visible"
  }

  //////////////////////////////////////////////////////////////

  const Header = ({ title, onEdit, onAdd }) => (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: "1fr auto",
        alignItems: "center"
      }}
    >
      <Typography
        fontSize="18pt"
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          minWidth: 60,
          justifyContent: "flex-end"
        }}
      >
        {onEdit && (
          <Tooltip title="Редактировать">
            <IconButton size="small" onClick={onEdit}>
              <img src={EditIcon} width={18} />
            </IconButton>
          </Tooltip>
        )}

        {onAdd && (
          <Tooltip title="Добавить">
            <IconButton size="small" onClick={onAdd}>
              <img src={AddIcon} width={18} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  )

  const RackColumn = ({ tabs, setTabs, selectedRack, setSelectedRack }) => {
    const [editMode, setEditMode] = useState(false)

    const addRack = () => {

      const abc = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
        'U', 'V', 'W', 'X', 'Y', 'Z'
      ]

      if (tabs.length === abc.length) {return}

      const find_void_num = (list) => {
        console.log("list", list)
        if (list.length === 0) return 0;

        // Извлекаем номера из статусов и сортируем
        const numbers = list
          .filter((fel) => !fel.del)
          .map(item => abc.findIndex((fel) => fel === item.name))
          .sort((a, b) => a - b);

        console.log("numbers", numbers)

        let expected = 0;
        for (const num of numbers) {
          if (num === expected) {
            expected++; // продолжаем искать следующий
          } else {
            return expected; // найден пропущенный индекс
          }
        }

        // Если пропусков нет, возвращаем следующий за последним
        return expected;
      }

      // const name = abc[tabs.length % abc.length]
      const name = abc[find_void_num(tabs)]
      let tmp = [...tabs, { name, title: name }].sort((a, b) => {
          // Функция для проверки, начинается ли строка с русской буквы
          const isRussian = (str) => /^[а-яё]/i.test(str);
          
          const aIsRussian = isRussian(a.name);
          const bIsRussian = isRussian(b.name);
          
          // Если одна русская, а другая нет — русская всегда первой
          if (aIsRussian && !bIsRussian) return -1;
          if (!aIsRussian && bIsRussian) return 1;
          
          // Если обе из одной группы — стандартная сортировка по алфавиту
          return a.name.localeCompare(b.name);
      })
      console.log("tmp", tmp)
      setTabs(tmp)
    }

    const deleteRack = (name) => {
      setTabs((prev) => {
        let idx = prev.findIndex((fel) => fel.name === name) 
        prev[idx].del = true
        return prev
      })
    }

    return (
      <Box sx={columnSx}>
        <Box sx={{ flexShrink: 0 }}>
          <Header
            title="Добавить стеллаж"
            onEdit={() => setEditMode(p => !p)}
            onAdd={addRack}
          />
        </Box>
        <Box
          sx={{
            mt: 1,
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            scrollbarGutter: "stable"
          }}>
          <Box sx={{mt: 1}}>
            {tabs.filter((fel) => !fel.del).map((tab) => (
              <Box key={tab.name} sx={listItemSx}>
                <Box sx={itemLeftSx}>
                  <Box
                    sx={{
                      ...textWrapperSx,
                      ...(selectedRack === tab.name && selectedTextSx),
                      ...(selectedRack === tab.name && {
                        "&:hover": {
                          background: "#bcdbde"
                        }
                      })
                    }}
                    onClick={() => setSelectedRack(tab.name)}
                  >
                    {tab.title}
                  </Box>
                </Box>

                <Box sx={itemRightSx}>
                  {editMode && (
                    <IconButton onClick={() => deleteRack(tab.name)} sx={{ color: "#bcdbde", marginRight:'10px'}}>
                      <DeleteForeverIcon />
                    </IconButton>
                  )}
                </Box>
              </Box>
            ))}
            </Box>
        </Box>
      </Box>
    )
  }

  //////////////////////////////////////////////////////////////

  const ShelfColumn = ({ tables, setTables, selectedRack, selectedShelf, setSelectedShelf }) => {
  const [editMode, setEditMode] = useState(false)
  const [openedColorShelf, setOpenedColorShelf] = useState(null)
  const [palettePos, setPalettePos] = useState({ top: 0, left: 10})
  const buttonRefs = useRef({}) // храним ref каждой кнопки

  const shelves = tables.filter(t => t.tab === selectedRack)

  const colors = [
    { color: "#fffbbc", colorcircule: "#e8dd2f" },
    { color: "#c7d3ff", colorcircule: "#8ea5fd" },
    { color: "#ffb3b7", colorcircule: "#f87d83" },
    { color: "#fcc9ff", colorcircule: "#f79afc" },
    { color: "#b7f6b9", colorcircule: "#53f178" }
  ]

  const deleteShelf = (status) => {
      setTables(prev => prev.filter(t => t.status !== status))
    }


    const addShelf = () => {
      if (!selectedRack) {return}
      const find_void_num = (list) => {
        if (list.length === 0) return 1;

        // Извлекаем номера из статусов и сортируем
        const numbers = list
          .map(item => parseInt(item.status.split('-')[1]))
          .sort((a, b) => a - b);

        let expected = 1;
        for (const num of numbers) {
          if (num === expected) {
            expected++; // продолжаем искать следующий
          } else {
            return expected; // найден пропущенный индекс
          }
        }

        // Если пропусков нет, возвращаем следующий за последним
        return expected;
      }

      ////new status
      let st = selectedRack
      let t = find_void_num(shelves)
      let new_status = `${st}-${t}`
      ///////

      let tmp = JSON.parse(JSON.stringify(tables))

      var table = { name: new_status, status: new_status, color: "#e0e0e0", colorcircule: "#e0e0e0", items:[], tab:selectedRack}; // создание контейнера
      tmp.push(table); 
      tmp = tmp.sort((a, b) => parseInt(a.status.split('-')[1]) - parseInt(b.status.split('-')[1]))
      console.log("tmp", tmp)
      setTables(tmp)
    }

    // const addShelf = () => {
    //   const newShelf = {
    //     status: `${Date.now()}`,
    //     name: `Полка ${shelves.length + 1}`,
    //     tab: selectedRack,
    //     color: "#e0e0e0",
    //     colorcircule: "#e0e0e0",
    //     items: []
    //   }
    //   setTables([...tables, newShelf])
    // }

  const changeShelfColor = (status, colorObj) => {
    setTables(prev =>
      prev.map(t =>
        t.status !== status
          ? t
          : {
              ...t,
              color: colorObj.color,
              colorcircule: colorObj.colorcircule,
              items: t.items.map(i => ({
                ...i,
                color: colorObj.color,
                colorcircule: colorObj.colorcircule
              }))
            }
      )
    )
  }

  return (
    <Box sx={columnSx}>
      <Box sx={{ flexShrink: 0 }}>
        <Header
          title="Добавить полку"
          onEdit={selectedRack ? () => setEditMode(p => !p) : null}
          onAdd={selectedRack ? addShelf : null}
        />
      </Box>

      <Box
        sx={{
          mt: 1,
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
          scrollbarGutter: "stable"
        }}
      >
        <Box sx={{ mt: 1 }}>
          {shelves.map(shelf => (
            <Box key={shelf.status} sx={listItemSx}>
              <Box sx={itemLeftSx}>
                <Box
                  sx={{
                    ...textWrapperSx,
                    ...(selectedShelf === shelf.status && selectedTextSx),
                    ...(selectedShelf === shelf.status && {
                      "&:hover": { background: "#bcdbde" }
                    })
                  }}
                  onClick={() => setSelectedShelf(shelf.status)}
                >
                  {shelf.name}
                </Box>
              </Box>

              <Box sx={itemRightSx}>
                {editMode && (
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      gap: 1
                    }}
                  >
                    <Box
                      // @ts-ignore
                      ref={el => (buttonRefs.current[shelf.status] = el)}
                      onClick={() => {
                        const btn = buttonRefs.current[shelf.status]
                        if (btn) {
                          const rect = btn.getBoundingClientRect()
                          setPalettePos({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX })
                        }
                        setOpenedColorShelf(prev => (prev === shelf.status ? null : shelf.status))
                      }}
                      sx={{
                        width: 18,
                        height: 18,
                        borderRadius: 1,
                        background: shelf.color,
                        cursor: "pointer",
                        marginRight:'75px'
                      }}
                    />

                    {openedColorShelf === shelf.status && (
                      <Portal>
                        <Box
                          sx={{
                            position: "absolute",
                            top: palettePos.top,
                            left: palettePos.left,
                            background: "#fff",
                            p: 1,
                            borderRadius: 1,
                            display: "flex",
                            gap: 1,
                            boxShadow: 3,
                            zIndex: 1300,
                            marginLeft:'25px',
                            marginTop:'-27px'
                          }}
                        >
                          {colors.map((c, i) => (
                            <Box
                              key={i}
                              onClick={() => {
                                changeShelfColor(shelf.status, c)
                                setOpenedColorShelf(null)
                              }}
                              sx={{
                                width: 18,
                                height: 18,
                                borderRadius: 1,
                                background: c.color,
                                cursor: "pointer"
                              }}
                            />
                          ))}
                        </Box>
                      </Portal>
                    )}
                    <IconButton onClick={() => deleteShelf(shelf.status)} sx={{ color: "#bcdbde", marginLeft:'-80px', marginRight:'25px' }}> <DeleteForeverIcon /> </IconButton>
                    
                  </Box>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

  //////////////////////////////////////////////////////////////

  const CellColumn = ({ tables, setTables, selectedShelf }) => {
    const [editMode, setEditMode] = useState(false)

    const shelf = tables.find(t => t.status === selectedShelf)

    const deleteCell = (cellStatus) => {
      setTables(prev =>
        prev.map(t =>
          t.status !== selectedShelf
            ? t
            : {
                ...t,
                items: t.items.filter(c => c.status !== cellStatus)
              }
        )
      )
    }

    const addCell = () => {
      setTables(prev =>
        prev.map(t => {
          if (t.status !== selectedShelf) return t

          const find_void_num = (list) => {
            if (list.length === 0) return 1;

            // Извлекаем номера из статусов и сортируем
            const numbers = list
              .map(item => parseInt(item.status.split('_')[1]))
              .sort((a, b) => a - b);

            let expected = 1;
            for (const num of numbers) {
              if (num === expected) {
                expected++; // продолжаем искать следующий
              } else {
                return expected; // найден пропущенный индекс
              }
            }

            // Если пропусков нет, возвращаем следующий за последним
            return expected;
          }

          // const nextIndex = t.items.length + 1
          const nextIndex = find_void_num(t.items)

          return {
            ...t,
            items: [
              ...t.items,
              {
                name: nextIndex,
                status: `${t.status}_${nextIndex}`, 
                color: t.color,
                colorcircule: t.colorcircule
              }
            ].sort((a, b) => parseInt(a.status.split('-')[1]) - parseInt(b.status.split('-')[1]))
          }
        })
      )
    }

    return (
      <Box sx={columnSx}>
        <Box sx={{ flexShrink: 0 }}>
          <Header
            title="Добавить ячейку"
            onEdit={selectedShelf ? () => setEditMode(p => !p) : null}
            onAdd={selectedShelf ? addCell : null}
          />
        </Box>

        <Box
          sx={{
            mt: 1,
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            scrollbarGutter: "stable"
          }}>
          <Box sx={{mt: 1, marginLeft:'4px',}}>
            {shelf?.items.map(cell => (
              <Box key={cell.status} sx={listItemSx}>
                
                <Box sx={itemLeftSx}>
                  <Box sx={textWrapperSx}>{cell.status.replaceAll('_', '-')}</Box>
                </Box>

                <Box sx={itemRightSx}>
                  {editMode && (
                    <IconButton onClick={() => deleteCell(cell.status)} sx={{ color: "#bcdbde", marginRight:'50px' }}>
                      <DeleteForeverIcon />
                    </IconButton>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    )
  }

  //////////////////////////////////////////////////////////////

  export const SettingsDialog = ({
    open,
    onClose,
    listTabs,
    setListTabs,
    listTables,
    setListTables
  }) => {
    const [tabs, setTabs] = useState(JSON.parse(JSON.stringify(listTabs)))
    const [tables, setTables] = useState(JSON.parse(JSON.stringify(listTables)))
    const [changed, setChanged] = useState(false)

    const [selectedRack, setSelectedRack] = useState(null)
    const [selectedShelf, setSelectedShelf] = useState(null)

    const handleSave = () => {
      setListTabs(tabs)
      setListTables(tables)
      setChanged(false)
      onClose()
    }

    const rightSetTabs = (data) => {
      setChanged(true)
      setTabs(data)
    }
    const rightSetTables = (data) => {
      setChanged(true)
      setTables(data)
    }

    const checkClose = () => {
      if (changed) {
        setTabs(JSON.parse(JSON.stringify(listTabs)))
        setTables(JSON.parse(JSON.stringify(listTables)))
      }
      onClose()
    }

    console.log("tabs", tabs)

    useEffect(() => {
      setSelectedShelf(null)
    }, [selectedRack])

    return (
      <Dialog
        open={open}
        onClose={checkClose}
        maxWidth="lg"
        scroll="paper"
       PaperProps={{
          sx: {
            width: 1000,
            height: 500,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
          }
        }}
      >
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}>
          
          <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
            <Box sx={{mt: 1, overflowY: "auto", width: "100%", overflowX:'hidden', scrollbarGutter: "stable", pr: "6px"}}>
              <RackColumn
                tabs={tabs}
                setTabs={rightSetTabs}
                selectedRack={selectedRack}
                setSelectedRack={setSelectedRack}
              />
            </Box>

            <Box sx={{mt: 1, overflowY: "auto", width: "100%", overflowX:'hidden', scrollbarGutter: "stable", pr: "6px"}}>
              <ShelfColumn
                tables={tables}
                setTables={rightSetTables}
                selectedRack={selectedRack}
                selectedShelf={selectedShelf}
                setSelectedShelf={setSelectedShelf}
              />
            </Box>

            <Box sx={{mt: 1, overflowY: "auto", width: "100%", overflowX:'hidden', scrollbarGutter: "stable", pr: "6px"}}>
              <CellColumn
                tables={tables}
                setTables={rightSetTables}
                selectedShelf={selectedShelf}
              />
            </Box>
          </Box>

          <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 1,
                marginLeft:'14px',
                marginRight:'30px',
                position: "sticky",
                bottom: 0,
                background: "#fff",
                pt: 1
              }}>
            <Button sx={{fontSize:'11.5pt'}} onClick={onClose}>Отмена</Button>
            <Button variant="contained" sx={{fontSize:'11.5pt'}} onClick={handleSave}>
              Сохранить
            </Button>
          </Box>

        </Box>
      </Dialog>
    )
  }

  // @ts-ignore
  // function NewStellag({onEdit, onClose, tabs}) {

  //   const { company_id} = useSelector(
  //     loginSelector
  //   );

  //   console.log("AAAAATABS", tabs)

  //   const [localTabs, setLocalTabs] = useState(tabs)

  //   const addStellage = () => {

  //     const abc = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ъ', 'Ы', 'Ь', 'Э', 'Ю', 'Я', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

  //     let tmp = JSON.parse(JSON.stringify(localTabs))
  //     let name = ""
  //     let title = ""
  //     if (tmp.length > 0) {
  //       name = abc[tmp.length%abc.length]
  //       title = name
  //     }
  //     else {
  //       name = "A"
  //       title = "A"
  //     }
  //     let nt = {company_id, name, title}
  //     tmp.push(nt)
  //     setLocalTabs(tmp)
  //   }

  //   const save = () => {onEdit(localTabs)}

  //   // @ts-ignore
  //   const setTabTitle  = (tname, val) => {
  //     let tmp = JSON.parse(JSON.stringify(localTabs))
  //     let idx = tmp.findIndex((fel) => fel.name === tname)
  //     tmp[idx].title = val
  //     setLocalTabs(tmp)
  //   }

  //   const delTab = (tname) => {
  //     let tmp = JSON.parse(JSON.stringify(localTabs))
  //     let idx = tmp.findIndex((fel) => fel.name === tname)
  //     tmp[idx].del = true
  //     setLocalTabs(tmp)
  //   }

  //   return (
  //     <div style={{margin: "20px"}}>
  //       <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
  //         <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', marginRight: "10px"}} onClick={addStellage}>Добавить стеллаж</Button>
  //       </div>  
  //       <div style={{display: "flex", flexDirection: "column"}}>
  //         <Scrollbars
  //           style={{height: "300px"}}
  //         >
  //           {localTabs.filter((fel) => !fel.del).map((tab) => {
  //             return (
  //               <div style={{display: "flex", flexDirection: "row"}}>
  //                   {/* <TextInput title={tab.name} val={tab.title} onChange={(v) => {setTabTitle(tab.name, v)}}></TextInput> */}
  //                   <TextFeature title={tab.name} val={tab.title}/>
  //                   <IconButton
  //                     color="inherit"
  //                     onClick={() => {delTab(tab.name)}}
  //                   >
  //                     <DeleteForeverIcon/>
  //                   </IconButton>
  //               </div>
  //             )
  //           })}
  //         </Scrollbars>
  //       </div>
  //       <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
  //         <Button variant="contained" sx={{textTransform: 'none', backgroundColor:'#078376', fontWeight: 'bold', marginRight: "10px"}} onClick={save}>Сохранить</Button>
  //       </div> 
  //     </div>
  //   )


  // } 